import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CommonService } from 'src/app/services/service.index';

@Injectable({
  providedIn: 'root'
})
export class SessionGuard implements CanActivate {
  constructor( private _commonServices:CommonService,
              private _router :Router){

  }   
  canActivate() {
  
    if((this._commonServices.getItemsessionStorage("sessionData"))==undefined){
      this._router.navigate(["login"])
      return false;
    }
    return true;
  }

  
}
